__turbopack_context__.v({
  "description": "SearchHeader-module-scss-module__clRyCW__description",
  "descriptionContent": "SearchHeader-module-scss-module__clRyCW__descriptionContent",
  "descriptionContentTruncated": "SearchHeader-module-scss-module__clRyCW__descriptionContentTruncated",
  "fade-in": "SearchHeader-module-scss-module__clRyCW__fade-in",
  "header": "SearchHeader-module-scss-module__clRyCW__header",
  "heading": "SearchHeader-module-scss-module__clRyCW__heading",
  "label": "SearchHeader-module-scss-module__clRyCW__label",
  "no-transform": "SearchHeader-module-scss-module__clRyCW__no-transform",
  "rotate": "SearchHeader-module-scss-module__clRyCW__rotate",
});
